<template>
	<QuestionMarkCircle
		v-tooltip="{
			content: 'How InterviewAI Works',
			placement: 'bottom',
			popperClass: 'max-w-[250px] text-center! text-[12px]! leading-[16px]! font-[Roboto] tracking-[0.5%]'
		}"
		class="cursor-pointer"
		@click="startOnboardingHandler"
	/>
</template>

<script setup>
import { useRoute } from 'vue-router';
import { useInterviewAiOnboardingStore } from '../../store/interview-onboarding.store';

import QuestionMarkCircle from '../../icons/question-mark-circle.vue';

const interviewAiOnboarding = useInterviewAiOnboardingStore();

const route = useRoute();

const startOnboardingHandler = () => {
	if (route.name === 'interview-ai') {
		interviewAiOnboarding.startDashboardOnboardingHandler();
	} else if (route.name === 'interview-ai-interview') {
		interviewAiOnboarding.startInterviewOnboardingHandler();
	}
};
</script>
